import { render, staticRenderFns } from "./poster-list.vue?vue&type=template&id=75906a20&scoped=true"
import script from "./poster-list.vue?vue&type=script&lang=js"
export * from "./poster-list.vue?vue&type=script&lang=js"
import style0 from "./poster-list.vue?vue&type=style&index=0&id=75906a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75906a20",
  null
  
)

export default component.exports